import { render } from "./Loading.vue?vue&type=template&id=1066ef52"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/blue-jays-ticketfinder/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__